module.exports = __webpack_public_path__ + "assets/img/dzh-30.434d8d0e.jpg";